<template>
  <div class="group-list">
    <div class="group-head">分组列表</div>
    <div class="main">
      <div class="table">
        <ul class="table-head">
          <li class="head-title">组名</li>
          <li class="head-title active">人数</li>
          <li class="head-title active">组长</li>
          <li class="head-title">操作</li>
        </ul>
        <div v-for="(item, index) in groupUsers" :key="index">
          <ul class="table-main">
            <li class="main-item">{{ item.groupName === 'CLASS_UNGROUPED_MARK_IT' ? '未分组' : item.groupName }}</li>
            <li class="main-item">{{ (item.students && item.students.length) + (item.leaderRealName ? 1 : 0) }}</li>
            <li class="main-item active" @click="handleAddGroupLeader(item, index)" v-if="!item.leaderRealName">
              <div class="item-box">
                <img src="../../../assets/images/grade/group-add.png" alt="" class="icon-add">
                <p class="box-title">添加组长</p>
              </div>
            </li>
            <li class="main-item active" @click="handleDelGroupLeader(index)" v-else>
              <div class="item-box">
                <p class="box-title box-name">{{ item && item.leaderRealName }}</p>
                <img src="../../../assets/images/grade/icon-close.png" alt="" class="icon-add">
              </div>
            </li>
            <li class="main-item" @click="handleSet(item, index)">
              <img src="../../../assets/images/grade/group-edit.png" alt="" class="icon-edit">
            </li>
          </ul>
          <div class="add-group-user">
            <ul class="user-menu">
              <div class="btn-add" @click="handleAddAdmin(item, index)"
                   :class="item.students && item.students.length ? 'pb10' : ''">
                <img src="../../../assets/images/grade/group-add.png" alt="" class="icon-add">
                <p class="box-title">添加组员</p>
              </div>
              <li class="menu-li" v-for="(acc, cindex) in item.students" :key="cindex"
                  @click="handleRemove(acc, cindex)">
                <div class="li-box">
                  <p class="name">{{ acc && acc.realName }}</p>
                  <img src="../../../assets/images/grade/group-close.png" alt="" class="group-close">
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="add-group-admin" @click="handleAddGroup">
          <div class="btn-add btn-add2">
            <img src="../../../assets/images/grade/add-group-black.png" alt="" class="icon-add">
            <p class="box-title">添加组</p>
          </div>
        </div>
      </div>
      <div class="save-button" @click="handleSaveGroup">保存</div>
    </div>
    <dialogDel ref="dialogDel" :delMessage="delMessage" @handleDelSave="handleDelSave" @handleClose="handleDelClose">
    </dialogDel>
    <van-popup v-model="isPopopShow" round position="bottom" :style="{ height: '25%' }">
      <div class="popup-box">
        <ul class="popup-menu">
          <li class="menu-li" @click="handleEditGroup">修改组名</li>
          <li class="menu-li" @click="handleDelPopup">删除</li>
        </ul>
        <div class="footer" @click="handlePopupClose">取消</div>
      </div>
    </van-popup>
    <modelEdit ref="modelEdit" @handleEditSave="handleEditSave" @handleEditClose="handleEditClose"></modelEdit>
  </div>
</template>

<script>
import dialogDel from './dialogDel.vue'
import modelEdit from './modelEdit.vue'
import {debounce} from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
import {checkDelGroup} from '@/api/grade'

import {Toast} from 'vant'

const UserProfile = {
  components: {
    dialogDel,
    modelEdit
  },
  data() {
    return {
      isPopopShow: false,
      groupUsers: [],
      delMessage: '',
      isDelGroupLeader: false,
      // delGroupLeader: {},
      editObj: {},
      editIndex: 0,
      studentsALLList: [],
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    createGradeJSON() {
      return JSON.parse(`${sessionStorage.getItem('createGrade')}`)
    },
  },
  created() {
    const {groupUsers = [], groupUsersList = [], studentsList = [], studentsALLList = []} = this.createGradeJSON
    this.studentsList = studentsList
    this.studentsALLList = studentsALLList
    this.groupUsersList = groupUsersList
    this.groupUsersStorage = groupUsers
    this.handleInitgroup()
  },
  methods: {
    handleInitgroup() {
      if (this.groupUsersList && this.groupUsersList.length) {
        this.groupUsers = this.groupUsersList.map((acc, index) => {
          let accCopy = {...acc}
          if (acc.students && acc.students.length > 0) {
            accCopy.students = acc.students.filter(item => item.groupRoleType === 2)
          } else {
            accCopy.students = []
          }
          // accCopy.leaderRealName = acc.students.filter(item => item.groupRoleType === 1).length > 0 ? acc.students.filter(item => item.groupRoleType === 1)[0].realName : ''
          return accCopy
        }).filter(acc => (acc.students && acc.students.length >= 0))
        this.handleSaveGroup(false)
      } else {
        this.groupUsers = []
      }
    },
    handleEditClose() {

    },
    // 修改组名
    handleEditSave(val) {
      if (!val.id && this.editIndex !== '') {
        this.groupUsers[this.editIndex].groupName = val.groupName
        this.groupUsersList[this.editIndex].groupName = val.groupName
      } else {
        this.groupUsers.forEach(acc => {
          if (val.id && acc.userId === val.id) {
            acc.groupName = val.groupName
          }
        })
        this.groupUsersList.forEach(acc => {
          if (val.id && acc.userId === val.id) {
            acc.groupName = val.groupName
          }
        })
      }
      this.$forceUpdate()
      this.$refs.modelEdit.handleReset()
      this.updateSessionStorage('createGrade', {
        groupUsersList: this.groupUsers,
      })
    },
    // 删除
    handleDelPopup() {
      this.isPopopShow = false
      this.delMessage = '确认删除吗?'
      this.isDelPopup = true
      this.$refs.dialogDel.init(this.editObj)
    },
    // 修改组名
    handleEditGroup() {
      this.isPopopShow = false
      this.$refs.modelEdit.init(this.editObj)
    },
    handlePopupClose() {
      this.isPopopShow = false
      this.editObj = {}
      this.editIndex = 0
    },
    // 操作
    handleSet(item, index) {
      this.isPopopShow = true
      this.editObj = item
      this.editIndex = index
    },
    // 添加组长
    handleAddGroupLeader(item, index) {
      this.$router.push({
        path: '/selectGroupList',
        query: {
          index,
          isGroupLeader: true,
          classId: this.classId,
        }
      })
    },
    // 删除管理员
    handleDelGroupLeader(index) {
      this.delMessage = '确认移出?'
      this.isDelGroupLeader = true
      this.editIndex = index
      let item = this.groupUsersList[index].students.filter(item => item.groupRoleType === 1)[0]
      this.$refs.dialogDel.init(item)
    },
    // 过滤掉组里面的成员
    handleResetList(studentsALLList) {
      if (!studentsALLList) return
      let studentIdsSet = new Set()
      // 遍历groupUsersList并填充studentIdsSet
      if (this.createGradeJSON.groupUsersList && this.createGradeJSON.groupUsersList.length > 0) {
        this.createGradeJSON.groupUsersList.forEach(groupItem => {
          if (groupItem.students && groupItem.students.length > 0) {
            groupItem.students.forEach(item => {
              studentIdsSet.add(item.id)
            })
          }
        })
      }
      // 筛选出不在studentIdsSet中的学生
      let studentsNotInGroups = studentsALLList.filter(student => {
        return !studentIdsSet.has(student.id)
      })
      return studentsNotInGroups
    },
    // 分组保存
    handleSaveGroup(noSave) {
      const newGroupList = this.handleResetList(this.studentsALLList)
      const item = {
        groupName: 'CLASS_UNGROUPED_MARK_IT',
        classId: '',
        createTime: Date.parse(new Date()),
        isDropDown: true,
        students: newGroupList
      }
      let groupUsers = this.groupUsersList.concat(item)
      this.updateSessionStorage('createGrade', {
        groupUsers,
        groupUsersList: this.groupUsersList,
        studentsList: this.studentsList,
      })
      if (!noSave) return
      this.$router.go(-1)
    },
    // 添加组
    handleAddGroup() {
      this.groupUsersList.push({
        classId: '',
        createTime: Date.parse(new Date()),
        groupName: `${this.groupUsers.length + 1}组`,
        isDropDown: true,
        leaderRealName: '',
        userId: '',
        students: []
      })
      this.updateSessionStorage('createGrade', {
        groupUsersList: this.groupUsersList,
        studentsList: this.studentsList
      })
      this.handleInitgroup()
    },
    handleRemove(acc, index) {
      this.isDelGroupLeader = false
      this.isDelPopup = false
      this.delMessage = '确认移出?'
      this.$refs.dialogDel.init(acc)
    },
    // 校验是否可以删除分组
    async checkDelGroup() {
      try {
        const item = this.groupUsersList.find((_, index) => this.editIndex === index)
        const res = await checkDelGroup({groupId: item.id})
        if (res.code === 0) {
          if (!res.data) {
            Toast('该分组当前已有绑定帖子，无法删除')
            return false
          } else {
            return true
          }
        } else {
          Toast('删除校验失败')
          return false
        }
      } catch (e) {
        Toast('删除校验失败')
        return false
      }
    },
    // 删除成员
    handleDelSave: debounce(async function (removeItem) {
      let shouldUpdateStorage = false

      try {
        if (this.isDelPopup) { // 删除组
          const onOff = await this.checkDelGroup()
          if (!onOff) return

          if (this.editIndex >= 0 && this.editIndex < this.groupUsersList.length) {
            this.groupUsersList.splice(this.editIndex, 1)
            shouldUpdateStorage = true
          }
        } else if (this.isDelGroupLeader) { // 删除组长
          const group = this.groupUsersList[this.editIndex]
          if (group) {
            group.students = (group.students || []).filter(m => m.groupRoleType === 2)
            group.leaderRealName = ''
            group.userId = ''
            shouldUpdateStorage = true
          }
        } else { // 删除组员
          if (removeItem && removeItem.id != null) {
            this.groupUsersList.forEach(item => {
              item.students = (item.students || []).filter(m => m.id !== removeItem.id)
            })
            shouldUpdateStorage = true
          }
        }

        this.handleInitgroup()

        if (this.$refs.dialogDel) {
          this.$refs.dialogDel.init()
        }

        if (shouldUpdateStorage) {
          this.updateSessionStorage('createGrade', {
            groupUsersList: this.groupUsersList,
          })
        }
      } catch (error) {
        console.error('删除操作失败:', error)
      }
    }),
    updateSessionStorage(sessionStorageName, value) {
      let prevData = JSON.parse(sessionStorage.getItem(sessionStorageName))
      Object.keys(value).forEach(function (val, key) {
        prevData[val] = value[val]
      })
      sessionStorage.setItem(sessionStorageName, JSON.stringify(prevData))
    },
    handleDelClose() {
    },
    // 添加组员
    handleAddAdmin(item, index) {
      this.addGroupIndex = index
      this.$router.push({
        path: '/selectGroupList',
        query: {
          isGroupLeader: false,
          classId: this.classId,
          index
        }
      })
    },
    addGroup() {
      this.groups.push({name: `${this.groups.length + 1}组`, memberCount: 0, leader: '', members: []})
    },
    removeGroup(index) {
      this.groups.splice(index, 1)
    },
    removeMember(group, index) {
      group.members.splice(index, 1)
      group.memberCount--
    },
    save() {
      // 处理保存逻辑
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less">
.group-list {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: #F0F1F6;
  box-sizing: border-box;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 146px;
    background-image: url('../../../assets/images/grade/group-bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .group-head {
    font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
    font-weight: bold;
    font-size: 21px;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    background: linear-gradient(15.793760429655658deg, #EB1700 0%, #0B0401 43%, #000000 100%);
    -webkit-background-clip: text;
    /*将设置的背景颜色限制在文字中*/
    -webkit-text-fill-color: transparent;
    /*给文字设置成透明*/
    width: 84px;
    height: 21px;
    position: relative;
    margin-bottom: 26px;
    top: 22px;
    left: 12px;
    z-index: 66;
  }

  .main {
    position: relative;
    top: 26px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: #fff;
    height: calc(100vh - 90px);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding-bottom: 18px;

    .table {
      flex: 1;
      width: 100%;
      padding: 0 14px 16px 14px;
      box-sizing: border-box;

      .table-head {
        list-style: none;
        position: relative;
        display: flex;
        justify-content: space-between;
        padding: 16px 0 24px;

        .head-title {
          flex: 1;
          flex-flow: 1;
          width: 25%;
          text-align: left;
          align-items: center;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 600;
          font-size: 14px;
          color: #000000;

          .active {
            text-align: center;
          }

          &:last-child {
            text-align: right;
          }
        }
      }

      .table-main {
        display: flex;
        list-style: none;
        position: relative;
        display: flex;
        align-items: center;

        .main-item {
          flex: 1;
          text-align: left;
          margin-bottom: 16px;

          .item-box {
            text-align: center;
            display: flex;
            align-items: center;

            .icon-add {
              width: 10px;
              height: 10px;
              margin-right: 5px;
            }

            .box-title {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              font-size: 13px;
              color: #EB1700;
            }

            .box-name {
              color: #000;
              margin-right: 4px;
            }
          }

          &:last-child {
            text-align: right;
          }

          .icon-edit {
            width: 14px;
            height: 14px;
          }
        }

        .active {
          text-align: center;
        }
      }

      .add-group-user,
      .add-group-admin {
        padding-left: 8px;
        // min-height: 44px;
        display: flex;
        flex-flow: wrap;
        // align-items: center;
        justify-content: flex-start;
        background: #F2F3F7;
        border-radius: 6px;
        margin-bottom: 24px;
        padding: 10px 8px .1px 8px;

        .btn-add {
          width: 76px;
          height: 24px;
          background: #FFFFFF;
          border-radius: 30px;
          border: 1px solid #EB1700;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          margin-right: 8px;
          margin-bottom: 10px;

          .icon-add {
            width: 10px;
            height: 10px;
            margin-right: 5px;
          }

          .box-title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 13px;
            color: #EB1700;
          }
        }

        .user-menu {
          flex: 1;
          display: flex;
          flex-flow: wrap;
          justify-content: flex-start;

          .menu-li {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: calc((100% - 20px) / 4);
            max-width: 25%;
            flex: 1;
            margin-bottom: 10px;

            .li-box {
              width: 76px;
              height: 24px;
              background: #FFFFFF;
              border-radius: 4px;
              padding: 0 6px;
              box-sizing: border-box;
              justify-content: space-between;
              display: flex;
              align-items: center;

              .name {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 13px;
                color: rgba(106, 116, 129, 0.9);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .group-close {
                width: 13px;
                height: 13px;
              }
            }
          }
        }
      }

      .add-group-admin {
        height: 40px;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 30px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;

        .btn-add {
          border: none;

          &.btn-add2 {
            margin-bottom: 0;
            margin-right: 0;
          }

          .icon-add {
            width: 12px;
            height: 12px;
          }

          .box-title {
            color: #000;
            font-family: PingFang HK, PingFang HK;
            font-weight: 400;
            font-size: 14px;
          }
        }

      }
    }

    .save-button {
      position: relative;
      width: 100%;
      height: 42px;
      width: calc(100vw - 28px);
      height: 42px;
      border-radius: 100px;
      font-size: 16px;
      text-align: center;
      line-height: 42px;
      font-weight: 500;
      color: #fff;
      background-color: #EB1700;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;

    th,
    td {
      padding: 10px;
      text-align: left;

      &:first-child {
        text-align: center;
      }
    }

    th {
    }
  }

  .add-group {
    display: flex;
    justify-content: flex-end;

    button {
      padding: 10px 15px;
      background-color: #f44336;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;

      &:hover {
        background-color: #e53935;
      }
    }
  }

  .save-button {
    display: flex;
    justify-content: center;

    button {
      padding: 10px 15px;
      background-color: #2196F3;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;

      &:hover {
        background-color: #1E88E5;
      }
    }
  }
}

.popup-box {
  background: #F8F8F8;
  position: relative;

  .popup-menu {
    position: relative;
    list-style: none;
    display: flex;
    flex-direction: column;
    background: #fff;
    margin-bottom: 9px;

    .menu-li {
      height: 48px;
      border-bottom: 1px solid #F3F3F3;
      box-sizing: border-box;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 16px;
      color: #000000;
    }
  }

  .footer {
    flex: 1;
    height: 80px;
    background: #fff;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFang HK, PingFang HK;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.5);
  }
}</style>



// WEBPACK FOOTER //
// src/views/grade/components/gradeGroup.vue